// Tells GoKwik to re-scan for checkout/buy-now buttons as soon as the quick-add
// modal's content changes (new product loaded in, including right after it first
// opens). Without this, GoKwik only picks up new buttons on its own ~500ms poll —
// click Buy Now in that window and it's still the native, un-intercepted button,
// which skips the GoKwik popup and goes straight to checkout.
(function(){
  function ping(){
    try{ document.dispatchEvent(new CustomEvent('cart:refresh')); }catch(e){}
  }
  function watch(){
    var modal = document.getElementById('quick-add-modal-content');
    if(!modal || modal.__ccSynced) return;
    modal.__ccSynced = 1;
    new MutationObserver(ping).observe(modal, {childList:true, subtree:true});
  }
  if(document.readyState !== 'loading') watch();
  else document.addEventListener('DOMContentLoaded', watch);
  // the modal node can itself be added late (dialog markup lives in a shared section) — keep checking
  new MutationObserver(watch).observe(document.documentElement, {childList:true, subtree:true});
})();
